import { useNavigate } from '@tanstack/react-router';
import { memo, useCallback } from 'react';

import { merge } from '@/components';
import { Button, Flex, FlexProps, Heading, Text } from '@/components/core';
import { CloseIcon } from '@/components/icons';
import { CradlLogo } from '@/components/logos';
import { toOrganizationId, useGetOrganization } from '@/hooks/api';

export type UpgradeProps = FlexProps;

const IUpgrade = ({ className, ...rest }: UpgradeProps) => {
  const navigate = useNavigate();
  const { data: organization } = useGetOrganization(toOrganizationId('me'));

  const onTalkToSales = useCallback(() => {
    window.location.href = 'https://cal.com/cradlai/30min';
  }, []);

  return (
    <Flex col className={merge('p-md gap-md w-[20rem] items-center rounded-lg bg-white', className)} {...rest}>
      <Flex col className="gap-sm p-sm items-center text-center">
        <Flex className="relative w-full justify-center">
          <CradlLogo size="xl" className="size-12" />
          <Button className="absolute right-0" onPress={() => navigate({ to: '/' })}>
            <CloseIcon />
          </Button>
        </Flex>
        <Heading size="xl">Upgrade your plan to create more agents</Heading>
        <Text>
          You reached the limit of {organization?.numberOfAgentsAllowed} agents included in your current plan. Upgrade
          your plan to build new agents and automate even more.
        </Text>
      </Flex>

      <Flex col className="px-md w-full">
        <Button variant="primary" onPress={() => navigate({ to: '/settings/plans' })}>
          <Text>Go to plans</Text>
        </Button>
        <Button variant="plain" onPress={onTalkToSales}>
          <Text>Talk to sales</Text>
        </Button>
      </Flex>
    </Flex>
  );
};

export const Upgrade = memo(IUpgrade) as typeof IUpgrade;
